export default "__VITE_ASSET__aRcjs_6b__"